import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

const MABHero = () => {
  const t = useTranslations();
  return (
    <section
      className="bg-sandstone-200 pt-36 pb-16 text-sandstone-500 md:pt-32 lg:px-5"
      data-cy="MAB-hero"
    >
      <LayoutGrid className="content-between">
        <GridItem
          colStart={{ sm: 'main', md: 5 }}
          colEnd={{ sm: 'main', md: 16 }}
        >
          <Typography
            Element="h1"
            variant="h1"
            color="inherit"
            data-cy="MAB-hero-heading"
          >
            {t('mab_hero_heading')}
          </Typography>
        </GridItem>
        <GridItem
          colStart={{ sm: 'main', md: 9 }}
          colEnd={{ sm: 'main', md: 19 }}
        >
          <Typography
            Element="p"
            variant="h6"
            color="inherit"
            data-cy="MAB-hero-copy"
          >
            {t('mab_hero_copy')}
          </Typography>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default MABHero;
